import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function AffiliateTerms() {
  const { affiliate: a, refreshAffiliate } = useOutletContext() || {};
  if (!a) return null;

  const currentVersion = a.settings?.terms_version;
  const acceptedVersion = a.terms_accepted_version;
  const needsAccept = currentVersion && acceptedVersion !== currentVersion;

  const accept = async () => {
    try {
      await api.post("/me/affiliate/accept-terms");
      toast.success("Terms accepted");
      await refreshAffiliate?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to accept terms");
    }
  };

  return (
    <div className="space-y-6" data-testid="affiliate-terms-page">
      <div className="border border-slate-200 rounded-md bg-white p-6">
        <div className="flex items-center justify-between mb-3">
          <div className="eyebrow">Program Terms</div>
          <span className="text-[10px] font-mono uppercase tracking-widest text-slate-500" data-testid="terms-version">
            Version {currentVersion || "v1"}
          </span>
        </div>
        <div className="prose prose-sm max-w-none text-slate-700 whitespace-pre-wrap" data-testid="terms-text">
          {a.settings?.terms_text || "Affiliate terms of service. Commissions may be reversed for refunded, fraudulent, cancelled, or otherwise ineligible transactions."}
        </div>

        <div className="mt-6 flex flex-col sm:flex-row sm:items-center gap-3 pt-4 border-t border-slate-200">
          <div className="text-xs text-slate-600" data-testid="terms-accept-status">
            {acceptedVersion
              ? <>Accepted version <span className="font-mono">{acceptedVersion}</span>{a.terms_accepted_at ? ` on ${a.terms_accepted_at.slice(0, 10)}` : ""}.</>
              : "You have not accepted the current version."}
          </div>
          {needsAccept && (
            <button
              onClick={accept}
              data-testid="accept-terms-btn"
              className="sm:ml-auto inline-flex items-center gap-1.5 px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium"
            >
              Accept current terms
            </button>
          )}
        </div>
      </div>

      {needsAccept && (
        <div className="border border-amber-200 bg-amber-50 rounded-md p-4 text-sm text-amber-900" data-testid="terms-update-notice">
          Affiliate Program Terms have been updated. Please review and accept the new terms to continue participating.
        </div>
      )}
    </div>
  );
}
